<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/purchase/order' }">采购订单</el-breadcrumb-item>
                <el-breadcrumb-item>{{ isEdit ? '编辑订单' : isView ? '查看订单' : '新增订单' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-tabs v-model="activeTab" type="border-card">
            <!-- 基本信息 Tab -->
            <el-tab-pane label="基本信息" name="basic">
                <el-form :model="forms" ref="forms" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="采购订单号" prop="billCode">
                                <el-input v-model="forms.billCode" :disabled="true || isEdit || isView"
                                    style="max-width: 220px;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="单据类型" prop="billType" style="width:350px">
                                <el-select v-model="forms.billType" placeholder="请选择" :disabled="isView">
                                    <el-option label="标准采购" value="标准采购"></el-option>
                                    <el-option label="紧急采购" value="紧急采购"></el-option>
                                    <el-option label="委外加工" value="委外加工"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="制单日期" prop="billDate">
                                <el-date-picker v-model="forms.billDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="所属公司" prop="companyID">
                                <el-tree-select ref="companys" v-model="forms.companyID" :data="companys"
                                    :disabled="!!forms.companyID" @change="companyChange();" check-strictly
                                    :render-after-expand="false" style="width: 280px;" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="采购部门" prop="departmentID">
                                <el-tree-select ref="departments" v-model="forms.departmentID" :data="departments"
                                    clearable check-strictly :render-after-expand="false" style="width:220px"
                                    :disabled="isEdit || isView" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="外部单号" prop="externalNo">
                                <el-input v-model="forms.externalNo" :disabled="isView" style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="关联申请单" prop="requisitionBillCode">
                                <el-input v-model="forms.requisitionBillCode" :disabled="isEdit || isView"
                                    placeholder="多个用逗号分隔"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :xs="24">
                            <el-form-item label="金料汇总">
                                <el-input :model-value="goldSummaryText" type="textarea" :rows="2" disabled />
                            </el-form-item>
                            <el-form-item label="备注" prop="remark">
                                <el-input v-model="forms.remark" type="textarea" :rows="2"
                                    :disabled="isView"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <!-- 采购信息 Tab -->
            <el-tab-pane label="采购信息" name="supplier">
                <el-form :model="forms" ref="purchaseForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="采购员" prop="purchaserName">
                                <el-input v-model="forms.purchaserName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="采购日期" prop="purchaseDate">
                                <el-date-picker v-model="forms.purchaseDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-form :model="forms" ref="supplierForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="供应商" prop="supplierCode">
                                <el-select v-model="forms.supplierCode" filterable clearable placeholder="请选择供应商"
                                    :disabled="isEdit || isView" style="width:220px" @change="supplierChange">
                                    <el-option v-for="s in suppliers" :key="s.supplierCode"
                                        :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="供应商联系人" prop="supplierContactName">
                                <el-input v-model="forms.supplierContactName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="供应商电话" prop="supplierContactPhone">
                                <el-input v-model="forms.supplierContactPhone" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <!-- 交货信息 Tab -->
            <el-tab-pane label="交货信息" name="delivery">
                <el-form :model="forms" ref="deliveryForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="交货日期" prop="deliveryDate">
                                <el-date-picker v-model="forms.deliveryDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="收货联系人" prop="deliveryContactName">
                                <el-input v-model="forms.deliveryContactName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="收货联系电话" prop="deliveryContactPhone">
                                <el-input v-model="forms.deliveryContactPhone" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24">
                            <el-form-item label="交货地点" prop="deliveryAddress">
                                <el-input v-model="forms.deliveryAddress" :disabled="isView"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <!-- 付款信息 Tab -->
            <el-tab-pane label="付款信息" name="payment">
                <el-form :model="forms" ref="amountForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="币种" prop="currency">
                                <el-select v-model="forms.currency" :disabled="isView" style="width:220px">
                                    <el-option label="人民币" value="CNY"></el-option>
                                    <el-option label="美元" value="USD"></el-option>
                                    <el-option label="欧元" value="EUR"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="汇率" prop="exchangeRate">
                                <el-input-number v-model="forms.exchangeRate" :disabled="isView" :precision="6" :min="0"
                                    style="width:220px"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="税率(%)" prop="taxRate">
                                <el-input-number v-model="forms.taxRate" :disabled="isView" :precision="2" :min="0"
                                    :max="100" style="width:220px" @change="calculateTotals"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="总数量">
                                <el-input v-model="forms.totalQuantity" disabled style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="总金额">
                                <el-input v-model="forms.totalAmount" disabled style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="含税总额">
                                <el-input v-model="forms.totalTaxAmount" disabled style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <el-form :model="forms" ref="paymentForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="付款方式" prop="paymentMethod">
                                <el-select v-model="forms.paymentMethod" :disabled="isView" style="width:220px">
                                    <el-option label="现结" value="现结"></el-option>
                                    <el-option label="预付款" value="预付款"></el-option>
                                    <el-option label="月结" value="月结"></el-option>
                                    <el-option label="账期" value="账期"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="16">
                            <el-form-item label="付款条件" prop="paymentTerm">
                                <el-input v-model="forms.paymentTerm" :disabled="isView"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
        </el-tabs>

        <div style="text-align:left;margin-top:20px;">
            <el-button type="primary" icon="Select" @click="submit" v-if="!isView">保存</el-button>
            <el-button type="success" icon="Printer" @click="openProductionPrintPreview" v-if="billId">
                打印生产订单
            </el-button>
            <el-button icon="Back" @click="back">返回</el-button>
        </div>

        <!-- 订单明细 -->
        <div style="margin-top: 15px;">
            <el-card>
                <template #header>
                    <div style="display:flex;align-items:center;justify-content:space-between;">
                        <div>采购订单明细</div>
                        <div>
                            <el-button plain icon="Plus" type="primary" size="small" @click="addDetail" v-if="!isView"
                                :disabled="isEdit">
                                新增明细
                            </el-button>

                            <el-dropdown v-if="!isView" style="margin:0px 10px;" size="small">
                                <el-button plain icon="Upload" type="primary" size="small">
                                    数据操作
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <!-- <el-dropdown-item :disabled="isEdit">导入明细</el-dropdown-item> -->
                                        <el-dropdown-item @click="downloadDetails">下载明细</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </div>
                </template>

                <el-table ref="detailTable" :data="visibleDetails" stripe border style="width: 100%"
                    @selection-change="onProductionDetailSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" label="行号" width="55"></el-table-column>
                    <el-table-column prop="detailImg" label="图片" width="60">
                        <template v-slot="scope">
                            <el-image style="height: 32px; width: 32px" lazy :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'" :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                                <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" /></template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productCode" label="货品信息" width="160">
                        <template #default="{ row }">
                            <el-autocomplete v-model="row.productSearchText"
                                :fetch-suggestions="(queryString, cb) => searchProductAsync(queryString, cb, row)"
                                placeholder="输入货品编号/名称/条码搜索" :disabled="true || isView"
                                @select="(item) => handleProductSelect(item, row)" size="small" style="width:100%"
                                :trigger-on-focus="false" :debounce="300">
                                <template #default="{ item }">
                                    <div style="display: flex; justify-content: space-between;">
                                        <span style="font-weight: bold;">{{ item.detailCode }}</span>
                                        <span style="">{{ item.serialCode }}</span>
                                        <span style="color: #8492a6; font-size: 12px;">{{ item.detailName }}</span>
                                    </div>
                                </template>
                            </el-autocomplete>
                        </template>
                    </el-table-column>
                    <el-table-column prop="materialType" label="货品类型" width="110">
                        <template #default="{ row }">
                            <el-select v-model="row.materialType" size="small" :disabled="isView"
                                @change="onMaterialTypeChange(row)" style="width:100%">
                                <el-option label="成品" value="成品"></el-option>
                                <el-option label="配件" value="配件"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="finalProductGroup" label="回货成品分组" width="150">
                        <template #default="{ row }">
                            <el-select v-model="row.finalProductGroup" size="small" 
                                :disabled="isView || (!row.materialType)" 
                                placeholder="选择或输入分组" 
                                filterable 
                                allow-create 
                                default-first-option
                                style="width:100%">
                                <el-option v-for="group in finalProductGroups" 
                                    :key="group" 
                                    :label="group" 
                                    :value="group">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sourceType" label="配件来源" width="120">
                        <template #default="{ row }">
                            <el-select v-model="row.sourceType" size="small" :disabled="isView || row.materialType !== '配件'"
                                clearable @change="onSourceTypeChange(row)" style="width:100%">
                                <el-option label="直接采购" value="直接采购"></el-option>
                                <el-option label="自有库房" value="自有库房"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stockBoundID" label="库存明细" width="150">
                        <template #default="{ row }">
                            <div v-if="row.stockBoundText" style="font-size: 11px; line-height: 1.4;">
                                <div style="word-break: break-all; white-space: pre-wrap; margin-bottom: 4px;">
                                    {{ row.stockBoundText }}
                                </div>
                                <div style="display: flex; gap: 5px;">
                                    <el-button link size="small" @click="openStockSelector(row)" :disabled="isView">
                                        更换
                                    </el-button>
                                    <el-button link size="small" type="danger" @click="clearStockBound(row)" :disabled="isView">
                                        清除
                                    </el-button>
                                </div>
                            </div>
                            <el-button v-else size="small" :disabled="isView || row.sourceType !== '自有库房'"
                                @click="openStockSelector(row)">
                                选择库存
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="outStatus" label="出库状态" width="90">
                        <template #default="{ row }">
                            <el-tag v-if="row.outStatus === 1" type="success" size="small">已出库</el-tag>
                            <el-tag v-else-if="row.outStatus === 0" type="info" size="small">未出库</el-tag>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="outBillCode" label="出库单号" width="150" show-overflow-tooltip>
                        <template #default="{ row }">
                            <el-link v-if="row.outBillCode" type="primary" size="small" @click="viewOutBill(row.outBillCode)">
                                {{ row.outBillCode }}
                            </el-link>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="requisitionBillCode" label="来源申请单" width="180" show-overflow-tooltip>
                        <template #default="{ row }">
                            <el-text size="small">{{ row.requisitionBillCode || '-' }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="货品名称" width="200" show-overflow-tooltip>
                        <template #default="{ row }">
                            <el-text size="small">{{ row.productName || '-' }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierCode" label="供货工厂" width="130">
                        <template #default="{ row }">
                            <el-select v-model="row.supplierCode" filterable clearable placeholder="供应商"
                                :disabled="isView" style="width:100%" size="small" @change="(value) => {
                                    const selected = suppliers.find(s => s.supplierCode === value);
                                    row.supplierName = selected ? selected.supplierName : '';
                                }">
                                <el-option v-for="s in suppliers" :key="s.supplierCode"
                                    :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierProductCode" label="工厂款号" width="110">
                        <template #default="{ row }">
                            <el-input v-model="row.supplierProductCode" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productSpec" label="规格型号" width="150">
                        <template #default="{ row }">
                            <el-input v-model="row.productSpec" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitName" label="单位" width="80">
                        <template #default="{ row }">
                            <el-input v-model="row.unitName" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderQuantity" label="订单数量" width="130">
                        <template #default="{ row }">
                            <el-input-number v-model="row.orderQuantity" size="small" :disabled="isView"
                                @change="onDetailChange(row)" :precision="2" :min="0"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitPrice" label="单价" width="130">
                        <template #default="{ row }">
                            <el-input-number v-model="row.unitPrice" size="small" :disabled="isView"
                                @change="onDetailChange(row)" :precision="2" :min="0"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" width="70">
                        <template #default="{ row }">
                            <span>{{ row.amount || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxRate" label="税率(%)" width="120">
                        <template #default="{ row }">
                            <el-input-number v-model="row.taxRate" size="small" :disabled="isView"
                                @change="onDetailChange(row)" :precision="2" :min="0" :max="100"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxTotalAmount" label="含税金额" width="85">
                        <template #default="{ row }">
                            <span>{{ row.taxTotalAmount || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="requiredDate" label="要求到货" width="130">
                        <template #default="{ row }">
                            <el-date-picker v-model="row.requiredDate" type="date" size="small" :disabled="isView"
                                format="YYYY-MM-DD" style="width:100%"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stampText" label="字印" width="160">
                        <template #default="{ row }">
                            <el-input v-model="row.stampText" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeCode" label="收货仓库" width="120">
                        <template #default="{ row }">
                            <el-input v-model="row.storeCode" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" width="200">
                        <template #default="{ row }">
                            <el-input v-model="row.remark" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100" fixed="right">
                        <template #default="{ row, $index }">
                            <el-button @click="deleteDetailRow($index)" link size="small" type="danger"
                                v-if="!isView">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>

        <!-- 库存明细选择弹框 -->
        <el-dialog title="选择库存明细" v-model="showStockDialog" style="max-width:1200px; width: 100%;" destroy-on-close>
            <el-form :model="stockSearchForm" label-width="110px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="货品批次号">
                            <el-input v-model="stockSearchForm.serialCode" placeholder="请输入批次号" clearable
                                @keyup.enter="searchStock"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="系统款号">
                            <el-input v-model="stockSearchForm.detailCode" placeholder="请输入系统款号" clearable
                                @keyup.enter="searchStock"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="品牌款号">
                            <el-input v-model="stockSearchForm.brandModelCode" placeholder="请输入品牌款号" clearable
                                @keyup.enter="searchStock"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="库房">
                            <el-input v-model="stockSearchForm.storeCode" placeholder="请输入库房编码" clearable
                                @keyup.enter="searchStock"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="渠道">
                            <el-input v-model="stockSearchForm.channel" placeholder="请输入渠道" clearable
                                @keyup.enter="searchStock"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="text-align:center;">
                        <el-button type="primary" icon="Search" @click="searchStock"
                            :loading="stockSearchLoading">查询库存</el-button>
                        <el-button @click="resetStockSearchForm">重置</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-divider></el-divider>

            <!-- 查询结果表格 -->
            <el-table :data="stockSearchResults" border style="width: 100%; margin-top: 10px;" size="small" max-height="400"
                v-loading="stockSearchLoading" highlight-current-row @current-change="handleStockSelect">
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column prop="serialCode" label="批次号" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="detailCode" label="系统款号" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="detailName" label="货品名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="storeCode" label="库房" width="80" align="center"></el-table-column>
                <el-table-column prop="channel" label="渠道" width="80" align="center"></el-table-column>
                <el-table-column prop="stockDate" label="入库时间" width="100" align="center">
                    <template #default="scope">
                        {{ (scope.row.stockDate || '').split(' ')[0] }}
                    </template>
                </el-table-column>
                <el-table-column prop="stockRemain" label="可用数量" width="90" align="center">
                    <template #default="scope">
                        <el-tag type="success">{{ scope.row.stockRemain || 0 }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template #default="{ row }">
                        <el-button link size="small" type="primary" @click="selectStockBound(row)">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="showStockDialog = false">取消</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 生产订单打印预览 -->
        <el-dialog v-model="productionPrintDialogVisible" title="生产订单打印预览" width="95%" top="3vh"
            destroy-on-close :close-on-click-modal="false" class="production-print-dialog">
            <div v-loading="productionPrintLoading" element-loading-text="正在生成生产订单模板">
                <section v-if="!productionPrintLoading" ref="productionPrintRef" id="production-print-panel"
                    class="production-print-sheet">
                    <article v-for="item in productionPrintData" :key="item.id || item.lineNo"
                        class="production-print-page">
                        <header class="production-print-header">
                            <div class="production-print-title-area">
                                <h1>生产订单</h1>
                                <div class="production-print-master-grid">
                                    <div v-for="field in productionPrintMasterFields" :key="field.label"
                                        class="production-master-field">
                                        <span>{{ field.label }}：</span><strong>{{ field.value }}</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="production-print-barcode-area">
                                <svg class="production-print-barcode"
                                    :data-barcode-value="productionPrintMaster.billCode || ''"></svg>
                                <div>{{ productionPrintMaster.billCode || '' }}</div>
                            </div>
                        </header>

                        <div class="production-print-detail-content">
                            <div class="production-print-detail-heading">
                                <span>明细 {{ item.lineNo || '-' }}</span>
                                <strong>{{ item.detailName || item.productName || '未命名货品' }}</strong>
                                <em>款号：{{ item.detailCode || item.productCode || '' }}</em>
                            </div>
                        <div class="production-print-parameter-area">
                            <template v-for="row in item.rows" :key="row.key">
                                <div v-if="row.title" class="production-section-title-row">
                                    <div class="production-section-title">{{ row.title }}</div>
                                </div>
                                <div v-else class="production-row">
                                    <div v-for="cell in row.cells" :key="cell.label" class="production-cell">
                                        <span class="production-cell-label">{{ cell.label }}</span>
                                        <b class="production-cell-value">{{ cell.value }}</b>
                                    </div>
                                </div>
                            </template>
                        </div>
                        </div>

                        <section class="production-spu-images"
                            :class="'production-spu-image-count-' + item.images.length">
                            <div class="production-spu-images-title">产品图片（3/4 视图）</div>
                            <div v-if="item.images.length" class="production-spu-image-grid">
                                <figure v-for="image in item.images" :key="image.id || image.src"
                                    class="production-spu-image-item">
                                    <figcaption>{{ image.label }}</figcaption>
                                    <div class="production-spu-image-frame">
                                        <img v-if="!image.failed" :src="image.src"
                                            :alt="(item.productName || item.detailName || 'SPU') + image.label"
                                            @error="handleProductionSpuImageError(image)">
                                        <span v-else>图片加载失败</span>
                                    </div>
                                </figure>
                            </div>
                            <div v-else class="production-spu-image-empty">暂无 SPU 图片</div>
                        </section>
                    </article>
                    <div v-if="productionPrintData.length === 0" class="production-print-empty">没有可打印的已保存货品明细</div>
                </section>
            </div>
            <template #footer>
                <el-button @click="productionPrintDialogVisible = false">取消</el-button>
                <el-button type="primary" icon="Printer" :loading="productionPrinting" :disabled="productionPrintLoading || !productionPrintData.length"
                    @click="printProductionOrder">确认打印</el-button>
            </template>
        </el-dialog>

    </el-card>
</template>

<script>
import { fetchBillCode, fetchPurchaseSupplier, fetchPurchaseBrand } from '@/api/purchase'
import { searchSkuList, fetchSkuByDetailCode } from '@/api/product'
import { fetchGroupBySerialCode } from '@/api/stock'
import { fetchFileList } from '@/api/basic'
import printJS from 'print-js'
import JsBarcode from 'jsbarcode'

export default {
    name: 'PurchaseOrderBill',
    components: {},
    data() {
        return {
            apiUrl: '',
            activeTab: 'basic',
            companys: [],
            departments: [],
            suppliers: [],
            brands: [],

            details: [],
            forms: {
                billDate: new Date(),
                status: 0,
                totalQuantity: 0,
                totalAmount: 0,
                taxRate: 13,
                taxAmount: 0,
                totalTaxAmount: 0,
                currency: 'CNY',
                exchangeRate: 1,
                deliveryStatus: 0,
                closeStatus: 0,
                companyID: '',
                companyName: '',
                departmentID: '',
                departmentName: '',
                billCode: '',
                billType: '',
                externalNo: '',
                requisitionBillCode: '',
                supplierId: '',
                supplierCode: '',
                supplierName: '',
                supplierContactName: '',
                supplierContactPhone: '',
                purchaserName: '',
                purchaseDate: null,
                deliveryDate: null,
                deliveryAddress: '',
                deliveryContactName: '',
                deliveryContactPhone: '',
                paymentMethod: '',
                paymentTerm: '',
                remark: ''
            },
            detailQuery: {
                page: 1,
                rows: 1000,
                filters: [],
                sidx: 'lineNo',
                sord: 'asc'
            },
            // 库存选择弹框相关数据
            showStockDialog: false,
            currentSelectingRow: null, // 当前正在选择库存的明细行
            stockSearchForm: {
                serialCode: '',
                detailCode: '',
                brandModelCode: '',
                storeCode: '',
                channel: ''
            },
            stockSearchResults: [],
            stockSearchLoading: false,
            selectedStockBound: null,
            productionPrintDialogVisible: false,
            productionPrintLoading: false,
            productionPrinting: false,
            productionPrintMaster: {},
            productionPrintData: [],
            selectedProductionDetails: []
        }
    },
    computed: {
        isEdit() { return this.$route.query.id && this.$route.query.mode !== 'view' },
        isView() { return this.$route.query.mode === 'view' },
        billId() { return this.$route.query.id },
        // 过滤未删除的明细数据
        visibleDetails() {
            return this.details.filter(detail => !detail.deleteMark);
        },
        goldSummaryText() {
            return this.buildGoldSummary(this.visibleDetails, false)
        },
        // 获取所有成品类型的回货成品分组集合（去重）
        finalProductGroups() {
            const groups = new Set();
            this.details.forEach(detail => {
                if (detail.materialType === '成品' && detail.finalProductGroup) {
                    groups.add(detail.finalProductGroup);
                }
            });
            return Array.from(groups);
        },
        productionPrintMasterFields() {
            const master = this.productionPrintMaster;
            const fields = [];
            const add = (label, value) => {
                if (this.hasPrintValue(value)) fields.push({ label, value: this.formatPrintValue(value) });
            };
            add('采购订单号', master.billCode || '-');
            add('单据类型', master.billType);
            add('所属公司', master.companyName);
            add('采购部门', master.departmentName);
            add('外部单号', master.externalNo);
            add('关联申请单', master.requisitionBillCode);
            add('制单日期', this.formatPrintDate(master.billDate));
            add('供应商', master.supplierName);
            add('采购员', master.purchaserName);
            add('下单日期', this.formatPrintDate(master.purchaseDate));
            add('出货日期', this.formatPrintDate(master.deliveryDate));
            return fields;
        }
    },
    mounted() {
        this.apiUrl = process.env.VUE_APP_BASEURL;
        this.$kaung.init(this.$options.name);

        this.$kaung.companys().then((res) => {
            this.companys = res;
            this.companyChange();
        });

        fetchPurchaseSupplier().then((res) => {
            if (res && res.code === 200) {
                this.suppliers = Array.isArray(res.data) ? res.data : []
            }
        });

        // 加载启用的品牌列表
        fetchPurchaseBrand().then((res) => {
            if (res && res.code === 200) {
                this.brands = Array.isArray(res.data) ? res.data : []
            }
        });

        if (this.billId) {
            this.load();
        } else {
            fetchBillCode(this.$options.name).then(res => {
                this.forms.billCode = res.data || '';
                this.forms.billType = '常规采购';
                this.forms.purchaserName = this.$store.getters.getUserInfo.realName || this.$store.getters.getUserInfo.userName || '';
                this.forms.companyID = this.$store.getters.getUserInfo.companyID || '';
                this.forms.departmentID = this.$store.getters.getUserInfo.departmentID || ''
                this.companyChange(this.forms.departmentID);
            })
        }
    },
    methods: {
        buildGoldSummary(details, includeActual) {
            const groups = new Map()
            ;(details || []).filter(item => item.goldMaterialCode).forEach(item => {
                const code = item.goldMaterialCode
                const current = groups.get(code) || { estimated: 0, actual: 0, own: 0, debt: 0 }
                current.estimated += Number(item.estimatedGoldWeight) || 0
                current.actual += Number(item.actualGoldWeight) || 0
                current.own += Number(item.ownGoldWeight) || 0
                current.debt += Number(item.supplierDebtGoldWeight) || 0
                groups.set(code, current)
            })
            if (!groups.size) return '不涉及金料'
            return Array.from(groups.entries()).map(([code, value]) => {
                const actual = includeActual ? `，实际 ${value.actual.toFixed(4)}g` : ''
                return `${code}：预计 ${value.estimated.toFixed(4)}g${actual}，自有 ${value.own.toFixed(4)}g，欠料 ${value.debt.toFixed(4)}g`
            }).join('；')
        },
        syncGoldSummaryRemark() {
            const clean = String(this.forms.remark || '').replace(/(?:^|\n)\[金料汇总\][^\n]*/g, '').trim()
            this.forms.remark = this.goldSummaryText === '不涉及金料'
                ? clean : [clean, `[金料汇总] ${this.goldSummaryText}`].filter(Boolean).join('\n')
        },
        // 搜索货品信息
        searchProductAsync(queryString, callback, row) {
            if (!queryString || queryString.trim().length < 2) {
                callback([]);
                return;
            }

            searchSkuList(queryString).then(res => {
                if (res && res.data && res.data.data) {
                    const suggestions = res.data.data.map(item => ({
                        value: `${item.detailName} [${item.detailCode}]${item.serialCode ? ' [' + item.serialCode + ']' : ''}`,
                        ...item
                    }));
                    callback(suggestions);
                } else {
                    callback([]);
                }
            }).catch(err => {
                console.error('Product search error:', err);
                callback([]);
            });
        },
        // 选择货品后填充信息
        handleProductSelect(item, row) {
            if (!item) return;

            row.productId = item.id || '';
            row.productCode = item.serialCode || item.brandModelCode || item.factoryModelCode || '';
            row.productName = item.detailName || '';
            row.productSpec = item.detailUnit || '';
            row.productBarcode = item.brandModelCode || item.factoryModelCode || item.serialCode || '';
            row.unitName = item.unitName || '';
            row.detailId = item.id || '';
            row.detailCode = item.detailCode || '';
            row.detailName = item.detailName || '';

            // 设置搜索文本为货品编号，便于显示和编辑
            row.productSearchText = item.detailCode || item.serialCode || item.brandModelCode || item.factoryModelCode || '';

            row.supplierCode = item.factoryCode || '';
            row.supplierName = item.factoryName || '';
            row.supplierProductCode = item.factoryModelCode || '';

            // 如果已设置订货数量，触发重新计算
            if (row.orderQuantity > 0) {
                this.onDetailChange(row);
            }

            this.$message.success('货品信息已填充');
        },
        load() {
            this.$kaung.getone(this.billId).then(res => {
                if (res.code === 200)
                    this.forms = { ...res.data };

                this.companyChange(this.forms.departmentID);
            });

            this.fetchDetails();
        },
        fetchDetails() {
            this.$kaung.fetch({ url: 'PurchaseOrderDetail/GetDetailList', params: { billId: this.billId }, method: 'get' })
                .then(res => {
                    if (res && res.code === 200) {
                        this.details = res.data.map(item => this.normalizeDetail(item));
                    }
                })
        },
        normalizeDetail(item) {
            const materialType = typeof item.materialType === 'string' ? item.materialType.trim() : item.materialType;
            return {
                ...item,
                materialType: materialType || '成品',
                productSearchText: item.productSearchText || item.detailCode || item.productCode || ''
            };
        },
        normalizeSubmitDetails() {
            this.details.forEach(detail => {
                const materialType = typeof detail.materialType === 'string' ? detail.materialType.trim() : detail.materialType;
                if (!detail.deleteMark && !materialType) {
                    detail.materialType = '成品';
                } else if (materialType !== detail.materialType) {
                    detail.materialType = materialType;
                }
            });
        },
        addDetail() {
            const newDetail = {
                id: null,
                billId: this.billId || '',
                lineNo: this.details.length + 1,
                productCode: '',
                productName: '',
                productSpec: '',
                unitName: '',
                productSearchText: '', // 用于autocomplete的搜索文本
                orderQuantity: 0,
                unitPrice: 0,
                amount: 0,
                taxRate: this.forms.taxRate || 13,
                taxAmount: 0,
                taxPrice: 0,
                taxTotalAmount: 0,
                deliveredQuantity: 0,
                remainQuantity: 0,
                requiredDate: '',
                brandCode: '',
                brandName: '',
                supplierCode: this.forms.supplierCode,
                supplierName: this.forms.supplierName,
                storeCode: '',
                storeName: '',
                status: 0,
                remark: '',
                stampText: '',
                deleteMark: false,
                _isNew: true,
                // 送料加工相关字段
                materialType: '成品',       // 货品类型：成品/配件
                finalProductGroup: '',      // 回货成品分组标识
                sourceType: '',             // 配件来源类型：直接采购/自有库房
                stockBoundID: '',           // 库存明细ID
                stockBoundText: '',         // 库存明细文本（后端返回，用于显示）
                outBillCode: '',            // 出库单号（只读）
                outDate: null,              // 出库日期（只读）
                outStatus: 0                // 出库状态：0未出库/1已出库（只读）
            }

            this.details.push(newDetail)
        },

        submit() {
            this.normalizeSubmitDetails();

            // 计算总计
            this.calculateTotals();

            // 首先验证表单
            this.$refs.forms.validate((valid) => {
                if (!valid) {
                    this.$message.error('请完善必填信息');
                    return false;
                }

                // 验证明细数据
                if (!this.details || this.details.length === 0) {
                    this.$message.error('请至少添加一条采购明细');
                    return false;
                }

                // 验证明细必填字段
                for (let i = 0; i < this.details.length; i++) {
                    const detail = this.details[i];
                    if (!detail.productCode || !detail.productName) {
                        this.$message.error(`第 ${i + 1} 行：货品编号和货品名称不能为空`);
                        return false;
                    }
                    if (!detail.orderQuantity || detail.orderQuantity <= 0) {
                        this.$message.error(`第 ${i + 1} 行：数量必须大于0`);
                        return false;
                    }
                    
                    // 送料加工字段验证
                    if (detail.materialType === '配件' && detail.sourceType === '自有库房') {
                        if (!detail.stockBoundID) {
                            this.$message.error(`第 ${i + 1} 行：配件来源为自有库房时，必须选择库存明细`);
                            return false;
                        }
                    }
                }

                // 保存数据
                this.syncGoldSummaryRemark()
                this.$kaung.post({ url: '/' + this.$options.name + '/ModifyForms', data: { master: this.forms, details: this.details } }).then(res => {
                    if (res.code === 200) {
                        this.$message({ message: res.content, type: res.type });
                        this.back();
                    }
                }).catch(err => {
                    this.$message.error('提交失败：' + (err.message || '未知错误'));
                });
            });
        },
        back() { this.$router.back() },

        companyChange(departmentID) {
            this.forms.departmentID = departmentID || '';
            this.departments = [];
            var that = this;
            if (this.forms.companyID) {
                this.$kaung.departments(this.forms.companyID).then((res) => {
                    that.departments = res;
                });
            }
        },

        supplierChange() {
            const supplier = this.suppliers.find(s => s.supplierCode === this.forms.supplierCode);
            if (supplier) {
                this.forms.supplierId = supplier.id || '';
                this.forms.supplierName = supplier.supplierName || supplier.text || '';
            }
        },

        onDetailChange(row) {
            const quantity = Number(row.orderQuantity) || 0;
            const price = Number(row.unitPrice) || 0;
            const taxRate = Number(row.taxRate) || 0;

            // 计算金额（未税）
            row.amount = (quantity * price).toFixed(2);

            // 计算税额
            row.taxAmount = (row.amount * taxRate / 100).toFixed(2);

            // 计算含税单价
            row.taxPrice = (price * (1 + taxRate / 100)).toFixed(2);

            // 计算含税金额
            row.taxTotalAmount = (parseFloat(row.amount) + parseFloat(row.taxAmount)).toFixed(2);

            // 计算剩余数量
            row.remainQuantity = quantity - (row.deliveredQuantity || 0);

            // 重新计算总计
            this.calculateTotals();
        },

        calculateTotals() {
            let totalQty = 0;
            let totalAmt = 0;
            let totalTaxAmt = 0;

            // 只计算未删除的明细
            this.details.forEach(detail => {
                if (!detail.deleteMark) {
                    totalQty += Number(detail.orderQuantity) || 0;
                    totalAmt += Number(detail.amount) || 0;
                    totalTaxAmt += Number(detail.taxTotalAmount) || 0;
                }
            });

            this.forms.totalQuantity = totalQty.toFixed(2);
            this.forms.totalAmount = totalAmt.toFixed(2);
            this.forms.taxAmount = (totalTaxAmt - totalAmt).toFixed(2);
            this.forms.totalTaxAmount = totalTaxAmt.toFixed(2);
        },

        deleteDetailRow(index) {
            this.$confirm('确定要删除该明细行吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 假删除：标记为删除而不是真正从数组中移除
                // 因为表格使用visibleDetails，所以需要找到原始details中对应的项
                const visibleItem = this.visibleDetails[index];
                const originalIndex = this.details.findIndex(d => d === visibleItem);
                
                if (originalIndex !== -1) {
                    this.details[originalIndex].deleteMark = true;
                    this.calculateTotals();
                    this.$message({ type: 'success', message: '已删除' });
                }
            }).catch(() => { })
        },

        onProductionDetailSelectionChange(selection) {
            this.selectedProductionDetails = selection || [];
        },

        async openProductionPrintPreview() {
            if (!this.billId) return;

            const selectedDetails = (this.selectedProductionDetails || []).filter(item => !item.deleteMark);
            if (!selectedDetails.length) {
                this.$message.warning('请先勾选需要打印的采购订单明细');
                return;
            }
            if (selectedDetails.some(item => !item.id)) {
                this.$message.warning('勾选项中包含未保存的明细，请先保存订单后再打印');
                return;
            }

            const selectedIds = new Set(selectedDetails.map(item => item.id));
            this.productionPrintDialogVisible = true;
            this.productionPrintLoading = true;
            this.productionPrintData = [];

            try {
                const results = await Promise.all([
                    this.$kaung.getone(this.billId),
                    this.$kaung.fetch({ url: 'PurchaseOrderDetail/GetDetailList', params: { billId: this.billId }, method: 'get' })
                ]);
                const masterRes = results[0];
                const detailsRes = results[1];

                if (!masterRes || masterRes.code !== 200)
                    throw new Error((masterRes && masterRes.content) || '获取采购订单主信息失败');
                if (!detailsRes || detailsRes.code !== 200)
                    throw new Error((detailsRes && detailsRes.content) || '获取采购订单明细失败');

                this.productionPrintMaster = { ...masterRes.data };
                const details = (Array.isArray(detailsRes.data) ? detailsRes.data : [])
                    .filter(item => !item.deleteMark && selectedIds.has(item.id))
                    .sort((left, right) => (Number(left.lineNo) || 0) - (Number(right.lineNo) || 0));

                if (!details.length || details.length !== selectedIds.size)
                    throw new Error('勾选的明细已发生变化，请刷新页面后重新选择');

                const detailCodes = [...new Set(details.map(item => item.detailCode).filter(Boolean))];
                const skuResults = await Promise.all(detailCodes.map(async detailCode => {
                    try {
                        const res = await fetchSkuByDetailCode(detailCode);
                        return [detailCode, res && res.code === 200 ? res.data : null];
                    } catch (error) {
                        console.warn('加载生产参数失败：' + detailCode, error);
                        return [detailCode, null];
                    }
                }));
                const skuMap = new Map(skuResults);
                const spuImageMap = await this.loadProductionSpuImageMap(skuMap);

                this.productionPrintData = details.map(detail => {
                    const sku = skuMap.get(detail.detailCode);
                    const spuKey = this.getProductionSpuKey(sku);
                    const images = spuKey && spuImageMap.has(spuKey) ? spuImageMap.get(spuKey) : [];
                    return this.buildProductionPrintItem(detail, sku, images);
                });

                this.productionPrintLoading = false;
                await this.$nextTick();
                this.renderProductionBarcodes();
            } catch (error) {
                console.error('生成生产订单打印模板失败', error);
                this.$message.error(error.message || '生成生产订单打印模板失败');
                this.productionPrintDialogVisible = false;
            } finally {
                this.productionPrintLoading = false;
            }
        },

        getProductionSpuKey(sku) {
            if (!sku || (!sku.productID && !sku.productCode)) return '';
            return `${sku.productID || ''}::${sku.productCode || ''}`;
        },

        async loadProductionSpuImageMap(skuMap) {
            const spuMap = new Map();
            skuMap.forEach(sku => {
                const key = this.getProductionSpuKey(sku);
                if (key && !spuMap.has(key)) spuMap.set(key, sku);
            });

            const results = await Promise.all([...spuMap.entries()].map(async ([key, sku]) => {
                try {
                    const res = await fetchFileList(sku.productID || '', sku.productCode || '');
                    const files = res && res.code === 200 && Array.isArray(res.data) ? res.data : [];
                    const images = files.map((file, index) => ({
                        id: file.id || `${key}-${index}`,
                        src: this.resolveProductionImageUrl(file.url || file.path),
                        label: this.productionImageLabel(index),
                        failed: false
                    })).filter(image => image.src).slice(0, 4);
                    return [key, images];
                } catch (error) {
                    console.warn('加载SPU图片失败：' + (sku.productCode || sku.productID || key), error);
                    return [key, []];
                }
            }));

            return new Map(results);
        },

        resolveProductionImageUrl(source) {
            if (!source) return '';
            try {
                const baseUrl = this.apiUrl || `${window.location.origin}/`;
                return new URL(source, baseUrl).href;
            } catch (error) {
                return source;
            }
        },

        productionImageLabel(index) {
            return ['图1', '图2', '图3', '图4'][index] || `图${index + 1}`;
        },

        buildProductionPrintItem(detail, sku, images = []) {
            const product = sku || {};
            const master = this.productionPrintMaster || {};
            const sizeUnit = product.productSizeUnit || '';

            // 单元格：标签始终保留，值空则以「-」占位（不再隐藏）
            const cell = (label, value) => ({
                label,
                value: this.hasPrintValue(value) ? this.formatPrintValue(value) : '-'
            });
            // 尺寸类字段统一追加 mm
            const dim = (label, value) => cell(label, this.hasPrintValue(value) ? value + 'mm' : '');
            // 石重类字段统一追加 ct
            const stoneW = (label, value) => cell(label, this.hasPrintValue(value) ? value + 'ct' : '');

            // 分组：始终显示标题 + 整组（空字段以「-」占位，不再整组隐藏）
            const section = (title, fieldRows) => [{ key: 'sec-' + title, title }, ...fieldRows];

            // 主石参数（对齐编辑页 主石参数 分页：名称/颜色/石重/尺寸 + 粒数/宽/高/厚 + 钻石色/净度/副石总重）
            const mainRows = [
                { key: 'main-a', cells: [
                    cell('主石名称', product.mainStoneName || product.stoneCode),
                    cell('主石颜色', product.mainStoneColor),
                    stoneW('主石石重', product.mainStoneWeight || product.stoneWeight),
                    dim('主石尺寸', product.mainStoneSize)
                ] },
                { key: 'main-b', cells: [
                    cell('主石粒数', product.mainStoneCount),
                    dim('主石宽', product.mainStoneWidth),
                    dim('主石高', product.mainStoneHeight),
                    dim('主石厚', product.mainStoneThickness)
                ] },
                { key: 'main-c', cells: [
                    cell('钻石颜色', product.diamondColor),
                    cell('钻石净度', product.diamondClarity),
                    stoneW('副石总重', product.sideStoneTotalWeight)
                ] }
            ];
            // 副石（对齐编辑页 副石N 分页：名称/颜色/粒数/石重/尺寸）
            const sideRows = (n) => [{
                key: 'side' + n,
                cells: [
                    cell('副石' + n + '名称', product['sideStone' + n + 'Name']),
                    cell('副石' + n + '颜色', product['sideStone' + n + 'Color']),
                    cell('副石' + n + '粒数', product['sideStone' + n + 'Count']),
                    stoneW('副石' + n + '石重', product['sideStone' + n + 'Weight']),
                    dim('副石' + n + '尺寸', product['sideStone' + n + 'Size'])
                ]
            }];

            // 标准费用（对齐编辑页 标准费用 分页）
            const feeRows = [
                { key: 'fee-a', cells: [
                    cell('总重范围', product.totalWeight),
                    cell('金重范围', product.metalWeight),
                    cell('费用克重', product.weightRange),
                    cell('样板克重', product.standardWeight)
                ] },
                { key: 'fee-b', cells: [
                    cell('克工费', product.laborUnitPrice),
                    cell('件工费', product.laborPiecePrice),
                    cell('附加费/件', product.additionalPieceFee),
                    cell('基础工费', product.baseLaborFee),
                    cell('金工费', product.goldLaborFee)
                ] },
                { key: 'fee-c', cells: [
                    cell('镶石费', product.stoneSettingFee),
                    cell('配石费', product.stoneMatchingFee),
                    cell('附加费1', product.extraFee1),
                    cell('附加费2', product.extraFee2),
                    cell('证书费', product.certificateFee)
                ] },
                { key: 'fee-d', cells: [
                    cell('其他费用', product.otherFee),
                    cell('入网费', product.networkFee),
                    cell('配件名称', product.accessoryName),
                    cell('配件费', product.accessoryFee),
                    cell('税点', this.hasPrintValue(product.taxRate) ? product.taxRate + '%' : '')
                ] },
                { key: 'fee-e', cells: [
                    cell('采购参考价', product.purchasePrice),
                    cell('售卖价', product.sellPrice),
                    cell('一口价', product.fixedPrice)
                ] }
            ];

            // 明细备注 + 生产备注
            const remarkParts = [];
            if (this.hasPrintValue(detail.remark)) remarkParts.push('明细：' + detail.remark);
            if (this.hasPrintValue(product.remark)) remarkParts.push('生产：' + product.remark);
            const remarkText = remarkParts.join('　');

            const rows = [
                // 基础明细（合并宽行：删订单级/标题块重复项，每行最多 4 格等分撑满）
                { key: 'b1', cells: [
                    cell('自定义款号', product.serialCode),
                    cell('产品大类', product.productBizType),
                    cell('品类大类', product.productCategoryType),
                    cell('品牌名称', detail.brandName || product.brandName)
                ] },
                { key: 'b2', cells: [
                    cell('品牌款号', product.brandModelCode),
                    cell('工厂名称', product.factoryName || detail.supplierName || master.supplierName),
                    cell('工厂款号', detail.supplierProductCode || product.factoryModelCode),
                    cell('材质', product.metalCode)
                ] },
                { key: 'b3', cells: [
                    cell('工艺', product.crafts),
                    cell('字印内容', detail.stampText || product.stampText),
                    cell('采购件数', this.hasPrintValue(detail.orderQuantity) ? detail.orderQuantity + (detail.unitName || '') : ''),
                    cell('配链名称', product.chainName)
                ] },
                { key: 'b4', cells: [
                    dim('产品高', product.productHeight),
                    dim('产品宽', product.productWidth),
                    dim('产品厚', product.productThickness),
                    cell('链材质', product.chainMaterial)
                ] },
                { key: 'b5', cells: [
                    cell('链颜色', product.chainColor),
                    cell('链功能', product.chainFunction)
                ] },
                // 石头分组（完整镜像编辑页）
                ...section('主石参数', mainRows),
                ...section('副石1', sideRows(1)),
                ...section('副石2', sideRows(2)),
                ...section('副石3', sideRows(3)),
                // 标准费用（完整镜像编辑页）
                ...section('标准费用', feeRows),
                // 备注
                { key: 'r-remark', cells: [ cell('备注', remarkText) ] }
            ];

            // 所有行/分组始终显示；空值已由 cell() 以「-」占位，不再隐藏

            return {
                ...detail,
                images: images.map(image => ({ ...image })),
                rows
            };
        },

        hasPrintValue(value) {
            return value !== undefined && value !== null && String(value).trim() !== '';
        },

        formatPrintValue(value) {
            return String(value);
        },

        formatPrintDate(value) {
            return value ? this.$util.fmtDate(value, 'yyyy-MM-dd') : '';
        },

        renderProductionBarcodes() {
            const root = this.$refs.productionPrintRef;
            if (!root) return;
            root.querySelectorAll('.production-print-barcode').forEach(barcode => {
                const value = barcode.dataset.barcodeValue;
                if (!value) return;
                try {
                    JsBarcode(barcode, value, { format: 'CODE128', displayValue: false, height: 44, width: 1.25, margin: 0 });
                } catch (error) {
                    console.error('生成生产订单条码失败', error);
                }
            });
        },

        handleProductionSpuImageError(image) {
            image.failed = true;
        },

        waitForProductionAssets() {
            const root = this.$refs.productionPrintRef;
            if (!root) return Promise.resolve();
            const images = Array.from(root.querySelectorAll('img'));
            return Promise.all(images.map(image => new Promise(resolve => {
                if (image.complete) {
                    resolve();
                    return;
                }
                image.onload = resolve;
                image.onerror = resolve;
            })));
        },

        async printProductionOrder() {
            if (!this.productionPrintData.length || !this.$refs.productionPrintRef) return;
            this.productionPrinting = true;
            try {
                await this.waitForProductionAssets();
                printJS({
                    printable: this.$refs.productionPrintRef.outerHTML,
                    type: 'raw-html',
                    targetStyles: ['*'],
                    style: this.productionPrintStyle()
                });
            } catch (error) {
                console.error('打印生产订单失败', error);
                this.$message.error('打印生产订单失败，请稍后重试');
            } finally {
                this.productionPrinting = false;
            }
        },

        productionPrintStyle() {
            return [
                '@page { size: A4 portrait; margin: 0; }',
                '* { box-sizing: border-box; }',
                'html, body { margin: 0; padding: 0; color: #171717; font-family: Microsoft YaHei, Arial, sans-serif; }',
                '.production-print-sheet { width: 210mm; margin: 0; font-size: 9.5px; line-height: 1.32; }',
                '.production-print-page { width: 210mm; min-height: 297mm; padding: 10mm; display: flex; flex-direction: column; overflow: visible; break-after: page; page-break-after: always; background: #fff; }',
                '.production-print-page:last-child { break-after: auto; page-break-after: auto; }',
                '.production-print-header { display: flex; flex: 0 0 auto; justify-content: space-between; gap: 7mm; border-bottom: 1px solid #222; padding-bottom: 2.5mm; margin-bottom: 3mm; }',
                '.production-print-title-area { flex: 1; min-width: 0; }',
                '.production-print-title-area h1 { margin: 0 0 2.5mm; text-align: center; font-size: 22px; font-weight: 600; letter-spacing: 5px; }',
                '.production-print-master-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); column-gap: 3mm; row-gap: 1.5mm; }',
                '.production-master-field { display: flex; min-width: 0; }',
                '.production-master-field span { color: #555; margin-right: 1mm; white-space: nowrap; }',
                '.production-master-field strong { min-width: 0; font-weight: 500; word-break: break-word; }',
                '.production-print-barcode-area { width: 38mm; flex: 0 0 38mm; text-align: center; font-size: 9px; overflow: hidden; }',
                '.production-print-barcode-area svg { width: 38mm; height: 16mm; display: block; margin: 1mm auto 0; }',
                '.production-print-detail-content { flex: 1 1 auto; min-height: 0; overflow: hidden; }',
                '.production-print-detail-heading { display: flex; align-items: baseline; gap: 2mm; border-bottom: 1px solid #ddd; padding-bottom: 1.2mm; margin-bottom: 1.5mm; }',
                '.production-print-detail-heading strong { font-size: 12px; }',
                '.production-print-detail-heading em { color: #555; font-style: normal; margin-left: auto; }',
                '.production-print-parameter-area { display: flex; flex-direction: column; gap: 0.8mm; }',
                '.production-row { display: flex; gap: 3mm; padding-bottom: 0.8mm; border-bottom: 1px dotted #e0e0e0; break-inside: avoid; }',
                '.production-cell { display: flex; align-items: baseline; min-width: 0; flex: 1 1 0; }',
                '.production-cell-label { flex: 0 0 auto; color: #666; white-space: nowrap; margin-right: 1mm; }',
                '.production-cell-label::after { content: "\\FF1A"; }',
                '.production-cell-value { flex: 1 1 auto; min-width: 0; font-weight: 500; word-break: break-word; }',
                '.production-section-title-row { break-inside: avoid; }',
                '.production-section-title { font-weight: 600; color: #333; font-size: 11px; margin: 1.8mm 0 0.8mm; padding-left: 1mm; border-left: 2.5mm solid #888; }',
                '.production-spu-images { flex: 0 0 auto; height: 98mm; margin-top: 3mm; display: flex; flex-direction: column; break-inside: avoid; }',
                '.production-spu-images.production-spu-image-count-3, .production-spu-images.production-spu-image-count-4 { height: 118mm; }',
                '.production-spu-images-title { flex: 0 0 auto; height: 5mm; line-height: 5mm; text-align: center; color: #555; font-weight: 600; margin-bottom: 1mm; }',
                '.production-spu-image-grid { width: 100%; flex: 1; min-height: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 2mm 4mm; }',
                '.production-spu-image-count-1 .production-spu-image-grid { grid-template-columns: minmax(0, 110mm); justify-content: center; }',
                '.production-spu-image-count-3 .production-spu-image-grid, .production-spu-image-count-4 .production-spu-image-grid { grid-template-rows: repeat(2, minmax(0, 1fr)); }',
                '.production-spu-image-item { min-width: 0; min-height: 0; margin: 0; display: flex; flex-direction: column; }',
                '.production-spu-image-item figcaption { flex: 0 0 auto; height: 4mm; text-align: center; color: #555; }',
                '.production-spu-image-frame { flex: 1; min-height: 0; display: flex; align-items: center; justify-content: center; overflow: hidden; border: 1px solid #ddd; }',
                '.production-spu-image-frame img { display: block; width: 100%; height: 100%; object-fit: contain; }',
                '.production-spu-image-frame span, .production-spu-image-empty { color: #999; }',
                '.production-spu-image-empty { height: 100%; display: flex; align-items: center; justify-content: center; border: 1px dashed #ccc; }',
                '.production-print-empty { padding: 18mm 0; text-align: center; color: #777; }'
            ].join('\n');
        },

        // 送料加工相关方法
        onMaterialTypeChange(row) {
            // 当货品类型变化时，重置相关字段
            if (row.materialType === '配件') {
                // 配件：显示回货成品分组和配件来源
                this.$message.info('💡 提示：配件需要设置回货成品分组，以便与成品合并入库');
            } else if (row.materialType === '成品') {
                // 成品：只显示回货成品分组，清空配件来源相关字段
                row.sourceType = '';
                row.stockBoundID = '';
                row.stockBoundText = '';
            } else {
                // 清空类型：清空所有送料加工相关字段
                row.finalProductGroup = '';
                row.sourceType = '';
                row.stockBoundID = '';
                row.stockBoundText = '';
            }
        },

        onSourceTypeChange(row) {
            // 当配件来源类型变化时，重置库存明细
            if (row.sourceType === '自有库房') {
                this.$message.info('💡 提示：选择自有库房后，审核订单时会自动从库存出库');
            } else {
                row.stockBoundID = '';
                row.stockBoundText = '';
            }
        },

        openStockSelector(row) {
            // 检查是否已选择公司
            if (!this.forms.companyID) {
                this.$message.warning('请先选择所属公司');
                return;
            }

            // 保存当前正在选择的行
            this.currentSelectingRow = row;
            
            // 重置搜索表单
            this.resetStockSearchForm();
            
            // 如果明细已有货品信息，自动填充到搜索条件
            if (row.productCode) {
                this.stockSearchForm.detailCode = row.detailCode || row.productCode;
            }
            
            // 打开弹框
            this.showStockDialog = true;
            this.stockSearchResults = [];
        },

        // 重置库存搜索表单
        resetStockSearchForm() {
            this.stockSearchForm = {
                serialCode: '',
                detailCode: '',
                brandModelCode: '',
                storeCode: '',
                channel: ''
            };
        },

        // 查询库存
        searchStock() {
            // 至少需要填写一个查询条件
            if (!this.stockSearchForm.serialCode && !this.stockSearchForm.detailCode && 
                !this.stockSearchForm.brandModelCode && !this.stockSearchForm.storeCode && 
                !this.stockSearchForm.channel) {
                this.$message.warning('请至少填写一个查询条件（推荐填写批次号或系统款号进行精确查询）');
                return;
            }

            this.stockSearchLoading = true;
            this.stockSearchResults = [];

            // 准备批次号数组
            const serialCodes = [];
            if (this.stockSearchForm.serialCode) {
                const codes = this.stockSearchForm.serialCode.split(',').map(code => code.trim()).filter(code => code);
                serialCodes.push(...codes);
            }

            // 调用库存查询接口
            fetchGroupBySerialCode(
                serialCodes,
                this.forms.companyID || '',
                this.stockSearchForm.detailCode || '',
                this.stockSearchForm.storeCode || '',
                this.stockSearchForm.channel || '',
                this.stockSearchForm.brandModelCode || ''
            ).then((res) => {
                this.stockSearchLoading = false;
                if (res.code === 200) {
                    // 过滤掉库存数量为0的记录
                    let queryResults = (res.data || []).filter(item => (item.stockRemain || 0) > 0);
                    if (queryResults.length === 0) {
                        this.$message.info('未找到符合条件的库存货品');
                    }
                    this.stockSearchResults = queryResults;
                } else {
                    this.$message.error(res.content || res.message || '查询失败');
                }
            }).catch((error) => {
                this.stockSearchLoading = false;
                console.error('查询库存失败:', error);
                this.$message.error('查询失败，请检查查询条件或稍后重试');
            });
        },

        // 处理库存选择（点击行）
        handleStockSelect(currentRow) {
            this.selectedStockBound = currentRow;
        },

        // 选择库存明细（点击选择按钮）
        selectStockBound(stockItem) {
            if (!this.currentSelectingRow) {
                this.$message.error('未找到目标明细行');
                return;
            }

            // 将库存信息填充到明细行
            this.currentSelectingRow.stockBoundID = stockItem.id || '';
            
            // 生成库存明细显示文本（格式：批次号-库房-渠道）
            const displayText = `${stockItem.serialCode || ''}-${stockItem.storeCode || ''}-${stockItem.channel || ''}`;
            this.currentSelectingRow.stockBoundText = displayText;

            // 如果明细行还没有填充货品信息，可以从库存信息中带入
            if (!this.currentSelectingRow.productCode) {
                this.currentSelectingRow.productCode = stockItem.detailCode || stockItem.serialCode;
                this.currentSelectingRow.productName = stockItem.detailName || '';
                this.currentSelectingRow.detailCode = stockItem.detailCode || '';
                this.currentSelectingRow.detailName = stockItem.detailName || '';
            }

            this.$message.success(
                `已选择库存明细：${stockItem.detailCode || stockItem.serialCode} - ${stockItem.detailName} (可用数量：${stockItem.stockRemain})`
            );

            // 关闭弹框
            this.showStockDialog = false;
            this.currentSelectingRow = null;
        },

        viewOutBill(outBillCode) {
            // 查看出库单详情（跳转到库存出库单页面）
            this.$message.info('查看出库单：' + outBillCode);
            // 实现跳转到出库单详情页
            this.$router.push({ path: '/stock/bills/detail', query: { billCode: outBillCode, mode: 'view' } });
        },

        // 清除选择的库存明细
        clearStockBound(row) {
            row.stockBoundID = '';
            row.stockBoundText = '';
            this.$message.success('已清除库存明细选择');
        },

        // 下载明细
        downloadDetails() {
            const billId = this.billId || '';
            if (!billId) {
                this.$message.warning('请先保存订单后再下载明细');
                return;
            }

            this.$kaung.fetch({
                url: '/PurchaseOrderDetail/DownloadTemplate',
                method: 'get',
                params: { billId: billId }
            }).then(res => {
                if (res && res.code === 200) {
                    this.$notify({
                        title: '导出成功',
                        message: res.content || '明细数据已导出',
                        type: 'success',
                        duration: 10000
                    });
                    if (res.data) {
                        window.location.href = process.env.VUE_APP_BASEURL + res.data;
                    } else {
                        this.$message.warning('后端未返回下载地址');
                    }
                } else {
                    this.$message.error(res.content || res.message || '下载明细失败');
                }
            }).catch(err => {
                console.error('下载明细失败:', err);
                this.$message.error('下载明细失败，请稍后重试');
            });
        }
    }
}
</script>

<style scoped>
.el-tabs {
    margin-bottom: 20px;
}

:deep(.el-tabs__content) {
    padding: 20px 10px;
}

:deep(.el-tab-pane) {
    min-height: 200px;
}

.production-print-sheet {
    width: 210mm;
    margin: 0 auto;
    background: #ebeef5;
    color: #171717;
    font-family: "Microsoft YaHei", Arial, sans-serif;
    font-size: 10px;
    line-height: 1.32;
}

.production-print-page {
    width: 210mm;
    height: 297mm;
    padding: 10mm;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    break-after: page;
    page-break-after: always;
}

.production-print-page + .production-print-page {
    margin-top: 18px;
}

.production-print-header {
    display: flex;
    flex: 0 0 auto;
    justify-content: space-between;
    gap: 7mm;
    padding-bottom: 2.5mm;
    margin-bottom: 3mm;
    border-bottom: 1px solid #222;
}

.production-print-title-area {
    flex: 1;
    min-width: 0;
}

.production-print-title-area h1 {
    margin: 0 0 2.5mm;
    text-align: center;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 5px;
}

.production-print-master-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.5mm 3mm;
}

.production-master-field {
    display: flex;
    min-width: 0;
}

.production-master-field span {
    color: #606266;
    white-space: nowrap;
}

.production-master-field span {
    margin-right: 1mm;
}

.production-master-field strong {
    min-width: 0;
    font-weight: 500;
    overflow-wrap: anywhere;
}

.production-print-barcode-area {
    width: 38mm;
    flex: 0 0 38mm;
    overflow: hidden;
    text-align: center;
    font-size: 9px;
}

.production-print-barcode-area svg {
    display: block;
    width: 38mm;
    height: 16mm;
    margin: 1mm auto 0;
}

.production-print-detail-content {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
}

.production-print-detail-heading {
    display: flex;
    align-items: baseline;
    gap: 2mm;
    padding-bottom: 1.2mm;
    margin-bottom: 1.5mm;
    border-bottom: 1px solid #dcdfe6;
}

.production-print-detail-heading strong {
    font-size: 12px;
}

.production-print-detail-heading em {
    margin-left: auto;
    color: #606266;
    font-style: normal;
}

.production-print-parameter-area {
    display: flex;
    flex-direction: column;
    gap: 0.8mm;
}

.production-row {
    display: flex;
    gap: 3mm;
    padding-bottom: 0.8mm;
    border-bottom: 1px dotted #e0e0e0;
}

.production-cell {
    display: flex;
    min-width: 0;
    align-items: baseline;
    flex: 1 1 0;
}

.production-cell-label {
    flex: 0 0 auto;
    color: #606266;
    white-space: nowrap;
    margin-right: 1mm;
}

.production-cell-label::after {
    content: '：';
}

.production-cell-value {
    flex: 1 1 auto;
    min-width: 0;
    font-weight: 500;
    word-break: break-word;
}

.production-section-title-row {
    break-inside: avoid;
}

.production-section-title {
    font-weight: 600;
    color: #303133;
    font-size: 11px;
    margin: 1.8mm 0 0.8mm;
    padding-left: 1mm;
    border-left: 2.5mm solid #909399;
}

.production-spu-images {
    height: 98mm;
    flex: 0 0 auto;
    margin-top: 3mm;
    display: flex;
    flex-direction: column;
    break-inside: avoid;
}

.production-spu-images.production-spu-image-count-3,
.production-spu-images.production-spu-image-count-4 {
    height: 118mm;
}

.production-spu-images-title {
    flex: 0 0 auto;
    height: 5mm;
    line-height: 5mm;
    text-align: center;
    color: #606266;
    font-weight: 600;
    margin-bottom: 1mm;
}

.production-spu-image-grid {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 2mm 4mm;
}

.production-spu-image-count-1 .production-spu-image-grid {
    grid-template-columns: minmax(0, 110mm);
    justify-content: center;
}

.production-spu-image-count-3 .production-spu-image-grid,
.production-spu-image-count-4 .production-spu-image-grid {
    grid-template-rows: repeat(2, minmax(0, 1fr));
}

.production-spu-image-item {
    min-width: 0;
    min-height: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
}

.production-spu-image-item figcaption {
    height: 4mm;
    flex: 0 0 auto;
    text-align: center;
    color: #606266;
}

.production-spu-image-frame {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #dcdfe6;
}

.production-spu-image-frame img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.production-spu-image-frame span,
.production-spu-image-empty {
    color: #909399;
}

.production-spu-image-empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #c0c4cc;
}

.production-print-empty {
    padding: 100px 0;
    color: #909399;
    text-align: center;
}

@media (max-width: 768px) {
    .production-print-sheet {
        width: 100%;
    }

    .production-print-page {
        transform-origin: top left;
    }
}
</style>
